<template>
    <VanBtn round class="dir-btn">
        <img src="./img/dir.png" alt="">
<!--        <span class="index"><span>{{ index }}</span>/{{ total }}</span>-->
        <span class="index">目录</span>
    </VanBtn>
</template>

<script>
    import { Button as VanBtn } from 'vant';
    export default {
        name: 'DirectoryBtn',
        // props: {
        //     index:{
        //         type: Number,
        //         default:0
        //     },
        //     total:{
        //         type: Number,
        //         default:0
        //     }
        // },
        methods:{

        },
        components:{
            VanBtn
        }
    }
</script>

<style lang="scss" scoped>
    .dir-btn{
        min-width: 88px;
        img{
            width: 13px;
            position: relative;
            top: 1px;
        }
        .index{
            font-size: 13px;
            color: #969CA8;
            margin-left: 4px;
            span{
                color: #FFA307;
            }
        }
    }
</style>
